import React from "react"
import { useTranslation } from "react-i18next"
import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import useGetLikes from "hooks/useGetLikes"
import BottomSheet from "components/atoms/BottomSheet"
import UsersList from "components/organisms/UsersList"

type LikedByBottomSheetProps = {
  show: boolean;
  id: number;
  onOpen: () => void;
  onClose: (selectedLists: number[]) => void;
}

export default function LikedByBottomSheet(props: LikedByBottomSheetProps) {
  const { id, show, onOpen, onClose } = props

  const { t } = useTranslation()

  const { users, isFetching } = useGetLikes(id, show)

  return (
    <BottomSheet
      id="likes-bottom-sheet"
      title={""}
      show={show}
      openBottomSheet={onOpen}
      closeBottomSheet={onClose}
    >
      <Container>
        <TitleWrapper>
          <Title>{t("items.likes")}</Title>
          <Count>{users?.length} {t("items.like")}</Count>
        </TitleWrapper>
        <UsersList
          users={users}
          loading={isFetching}
        />
      </Container>
    </BottomSheet>

  )
}

const Container = styled(Stack)(({ theme }) => ({
  width: "100%",
  height: "65vh",

  "& .MuiTextField-root": {
    marginBottom: "0 !important",
    padding: "0 4px"
  }
}))

const TitleWrapper = styled(Stack)(({ theme }) => ({
  width: "1005",
  flexDirection: "row",
  justifyContent: "space-between",
  marginBottom: "10px",
  padding: "0 4px"
}))

const Title = styled(Typography)(({ theme }) => ({
  fontSize: "1.2rem",
  fontWeight: 500,
  color: theme.palette.gray["15"]
}))

const Count = styled(Typography)(({ theme }) => ({
  fontSize: "1.2rem",
  fontWeight: 400,
  color: theme.palette.gray["12"],
  fontFamily: "VazirmatnFD, serif !important"
}))
